//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Object.js";
import "../Motion/Motion.MotionSession.js";
let d=[[],[[["analysis_type"],"SetAnalysisType",{},1,0],[["setting"],"SetJointWizardStatus",{},1,0],[[],"GetJointWizardStatus",{R_:{setting:''}},0,0],[["check_motor_license"],"CheckMotorLicense",{},1,0],[["check_cosim_license"],"CheckCosimLicense",{},1,0],[["check_flexbody_license"],"CheckFlexbodyLicense",{},1,0],[["component_based_mech"],"SetComponentBasedMechanism",{},1,0],[["solver"],"SetSolver",{},1,0],[[],"GetSolver",{R_:{solver:''}},0,0]],[]];
SPLM.Motion.MotionEnvironment = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.MotionEnvironment";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MotionEnvironment.Analysis = Object.freeze({
    "NoType" : "NoType", "Kinematics" : "Kinematics", "Dynamics" : "Dynamics"});

SPLM.Motion.MotionEnvironment.Solver = Object.freeze({
    "None" : "None", "Recurdyn" : "Recurdyn", "Adams" : "Adams", "Simcenter" : "Simcenter", "ScDesigner" : "ScDesigner"});

SPLM.Motion.MotionEnvironment.JointWizardStatus = Object.freeze({
    "Undefined" : "Undefined", "Off" : "Off", "On" : "On"});

export default SPLM;